import axios from 'axios';

class AptlyService {
  async connect(feedUrl: string): Promise<void> {
    try {
      await axios.post('/aptly/connect', { feedUrl });
    } catch (error) {
      console.error('Failed to connect Aptly:', error);
      throw new Error('Failed to connect Aptly integration');
    }
  }

  async disconnect(): Promise<void> {
    try {
      await axios.delete('/aptly/disconnect');
    } catch (error) {
      console.error('Failed to disconnect Aptly:', error);
      throw new Error('Failed to disconnect Aptly integration');
    }
  }
}

export default new AptlyService();
